import type { SeriesNullablePoints } from "@/components/charts/GRPCMetricChartImpl";
import { mappedCompare } from "@/utils/sort";

// Shared with the /kube-events page so its charts and the dashboard tiles draw alike.

const SEVERITY_ORDER = ["INFO", "WARNING", "ERROR", "CRITICAL"];

export const KUBE_EVENT_SEVERITY_COLORS: Record<string, string> = {
  INFO: "#bfdbfe", // blue-200
  WARNING: "#fde047", // yellow-300
  ERROR: "#ef4444", // red-400
  CRITICAL: "#991b1b", // red-800
};

/** The canonical colour for a severity, or undefined for a value that is not one, which a chart
 *  colours from its palette instead. */
export const kubeEventSeverityColor = (value: string): string | undefined =>
  KUBE_EVENT_SEVERITY_COLORS[value.trim().toUpperCase()];

export const sortKubeEventSeries = (series: SeriesNullablePoints[]): SeriesNullablePoints[] =>
  series
    .toSorted(mappedCompare((s) => SEVERITY_ORDER.indexOf(s.label) ?? Number.MAX_SAFE_INTEGER))
    .map((s) => ({ ...s, label: s.label.toUpperCase() }));
